import React from 'react';

const highLightText = (highlight, value) => {
    const parts = highlight.split(new RegExp(`(${value})`, 'gi'));
    return <span> { parts.map((part, i) =>
        <span key={i} style={part.toLowerCase() === value.toLowerCase() ? { color: '#998152' } : {} }>
            {part}
        </span>)
    } </span>;
};

export default highLightText;